import { render, staticRenderFns } from "./ClientSelectize.vue?vue&type=template&id=34eca6ca"
import script from "./ClientSelectize.vue?vue&type=script&lang=js"
export * from "./ClientSelectize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports